/**
 * @module components/progressRail
 *
 * The hairline reading-progress bar at the very top of the page.
 *
 * Implemented with a bare `ScrollTrigger` attached to the scroller rather than a
 * `scroll` listener, so it stays perfectly in sync when ScrollSmoother is
 * driving the scroll position.
 *
 * The bar writes to `transform: scaleX()` — never `width` — so updating it on
 * every scroll frame costs nothing beyond compositing.
 */

import { ScrollTrigger, registerPlugins } from "../core/gsap-setup.js";
import { qs } from "../core/dom.js";

/**
 * @returns {() => void} Teardown.
 */
export function initProgressRail() {
  registerPlugins();

  const bar = qs("[data-progress-bar]");
  if (!bar) return () => {};

  const write = (self) => {
    bar.style.transform = `scaleX(${self.progress.toFixed(4)})`;
  };

  const trigger = ScrollTrigger.create({
    start: 0,
    end: "max",
    onUpdate: write,
    onRefresh: write,
  });

  return () => trigger.kill();
}
